import PaymentMethodsAvailable from './payment-methods-available';

export default PaymentMethodsAvailable;
